<h2>Country Subdivision Data Mapping</h2>

<div class="px-2 py-3 contents h-full max-h-80" *ngIf="isLoadCountrySubdivisionMappingGridDataSource">
    <div class="mapping-grid-container shadow-lg">
        <dx-data-grid
            #countrySubdivisionMappingDataGrid
            id="countrySubdivisionMappingDataGrid"
            [allowColumnResizing]="true"
            [columnResizingMode]="'widget'"
            [allowColumnReordering]="true"
            [dataSource]="countrySubdivisionMappingDataSource"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [remoteOperations]="true"
            [hoverStateEnabled]="true"
            [(selectedRowKeys)]="countrySubdivisionMappingSelectedRowMap"
            (onSelectionChanged)="selectionMappingDataChangedHandler()"
            (onContentReady)="onReady($event)"
            (onContextMenuPreparing)="mappingDataGridContextMenu($event)"
            keyExpr="CountrySubdivisionMappingId"
        >
            <dxo-state-storing
                    [enabled]="true"
                    type="custom"
                    [customLoad]="loadMappingState"
                    [customSave]="saveMappingState">
            </dxo-state-storing>
            <dxo-load-panel
                    [enabled]="false"
                    shadingColor="rgba(0,0,0,0.4)"
                    [showIndicator]="true"
                    [showPane]="true"
                    [shading]="true">
            </dxo-load-panel>
            <dxo-filter-panel [visible]="true"></dxo-filter-panel>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-pager
                    [visible]="true"
                    [allowedPageSizes]="[5, 10, 25, 50, 100]"
                    displayMode="compact"
                    [showPageSizeSelector]="true"
                    [showNavigationButtons]="false"
            >
            </dxo-pager>
            <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
            <dxo-selection mode="single"></dxo-selection>
            <dxo-column-chooser [enabled]="true" mode="dragAndDrop"></dxo-column-chooser>
            <dxi-column dataField="CountrySubdivisionMappingId" caption="Mapping Id" [allowHeaderFiltering]="false" [width]="140" [customizeText]="customizeCountrySubdivisionGeographicalEntityId"></dxi-column>
            <dxi-column caption="Action" [allowHeaderFiltering]="false" cellTemplate="action" alignment="center"></dxi-column>
            <dxi-column dataField="SourceCountrySubdivision">
                <dxo-header-filter [dataSource]="sourceCountrySubdivisionHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="SourceCountry">
                <dxo-header-filter [dataSource]="sourceCountryHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="DataProviderCode">
                <dxo-header-filter [dataSource]="dataProviderCodeHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="DataProviderPrimaryOrDefaultCountryGeographicalEntityShortName" [visible]="false" caption="Data Provider Country Name">
                <dxo-header-filter [dataSource]="countryGeographicalEntityShortNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="DataProviderPrimaryOrDefaultCountryGeographicalEntityCountryAlpha2Code" [visible]="false" caption="Data Provider Country Code">
                <dxo-header-filter [dataSource]="countryGeographicalEntityCountryAlpha2CodeHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="IsDataProviderPrimaryOrDefaultCountryInconsistentMappingMessage" [visible]="false" caption="Data Provider Inconsistent Mapping">
                <dxo-header-filter [dataSource]="countryInconsistentMappingMessageHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountryShortName" [visible]="false">
                <dxo-header-filter [dataSource]="mappingCountryShortNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountryAlpha2Code" [visible]="false">
                <dxo-header-filter [dataSource]="mappingCountryAlpha2CodeHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="Alpha2CodeMismatchError" caption="Country Code Mismatch Error">
                <dxo-header-filter [dataSource]="countryAlpha2CodeMismatchErrorHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionShortName" caption="Country Subdivision Name">
                <dxo-header-filter [dataSource]="mappingCountrySubdivisionShortNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionTypeName" caption="Country Subdivision" [visible]="false">
                <dxo-header-filter [dataSource]="mappingCountrySubdivisionTypeNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionCountryAlpha2Code" caption="Country Subdivision Country Code" [visible]="false">
                <dxo-header-filter [dataSource]="mappingCountrySubdivisionCountryAlpha2CodeHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionCode">
                <dxo-header-filter [dataSource]="mappingCountrySubdivisionCodeHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionParentCode" caption="Country Subdivision Parent Code" [visible]="false">
                <dxo-header-filter [dataSource]="mappingCountrySubdivisionParentCodeHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionParentShortName" caption="Country Subdivision Parent Name" [visible]="false">
                <dxo-header-filter [dataSource]="mappingCountrySubdivisionParentShortNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionParentTypeName" caption="Country Subdivision Parent Type" [visible]="false">
                <dxo-header-filter [dataSource]="mappingCountrySubdivisionParentTypeNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column caption="Data auditing">
                <dxi-column dataField="CreatedByUserFullNameSortableOrPrincipalName" caption="Created By">
                    <dxo-header-filter [dataSource]="mappingCreatedByUserFullNameSortableOrPrincipalNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CreatedOn" caption="Create on" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="mappingCreatedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedByUserFullNameSortableOrPrincipalName" caption="Modified By">
                    <dxo-header-filter [dataSource]="mappingModifiedByUserFullNameSortableOrPrincipalNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedOn" caption="Modified on" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="mappingModifiedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedByUserFullNameSortableOrPrincipalName" caption="Reviewed By">
                    <dxo-header-filter [dataSource]="mappingReviewedByUserFullNameSortableOrPrincipalNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedOn" caption="Reviewed on" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="mappingReviewedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>
            <dxi-column dataField="CountryMappingModeName" caption="Country Mapping Mode" [allowHeaderFiltering]="false" [allowFiltering]="false">
            </dxi-column>
            <dxi-column dataField="CountryMappingModeId" caption="Country Mapping Mode Id" [alignment]="'left'">
                <dxo-header-filter [dataSource]="countryMappingModeNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="MappingModeName" caption="Mapping Mode" [allowHeaderFiltering]="false" [allowFiltering]="false">
            </dxi-column>
            <dxi-column dataField="MappingModeId" caption="Mapping Mode Id" [alignment]="'left'">
                <dxo-header-filter [dataSource]="mappingMappingModeName"></dxo-header-filter>
            </dxi-column>
            <div *dxTemplate="let action of 'action'">
                <dx-button class="mr-1" icon="fas fa-ban fa-1x" hint="Omit" [disabled]="action?.data?.MappingModeId == 3" (onClick)="omit(action?.data?.CountrySubdivisionMappingId)"></dx-button>
                <dx-button class="mr-1" icon="far fa-bookmark fa-1x" hint="Save" [disabled]="action?.data?.MappingModeId == 2" (onClick)="save(action?.data?.CountrySubdivisionMappingId)"></dx-button>
                <dx-button
                        id="btnAccept"
                        *ngIf="action?.data?.ModifiedByUserId <= 0 && action?.data?.MappingModeId == 0"
                        class="mr-1"
                        icon="fa fa-check fa-1x"
                        hint="Accept"
                        (onClick)="accept(action?.data?.CountrySubdivisionMappingId)"
                ></dx-button>
                <dx-button
                        id="btnReview"
                        class="mr-1"
                        *ngIf="action?.data?.ModifiedByUserId > 0 && action?.data?.ModifiedByUserId != currentUser?.UserId && action?.data?.ReviewedByUserId == -1"
                        icon="fas fa-check-double fa-1x"
                        hint="Review"
                        (onClick)="review(action?.data?.CountrySubdivisionMappingId)"
                ></dx-button>
                <dx-button *ngIf="currentUser?.UserRoleId > 1 && action?.data?.Active" icon="fas fa-trash-alt fa-1x" hint="Deactivate" (onClick)="deactivate(action?.data?.CountrySubdivisionMappingId)"></dx-button>
                <dx-button *ngIf="currentUser?.UserRoleId > 1 && !action?.data?.Active" icon="fas fa-trash-alt fa-1x" hint="Reactivate" (onClick)="reactivate(action?.data?.CountrySubdivisionMappingId)"></dx-button>
            </div>
            <dxo-paging [pageSize]="5"></dxo-paging>
        </dx-data-grid>
    </div>
</div>

<div class="py-3 block h-full" *ngIf="isLoadCountrySubdivisionMasterGridDataSource">
    <div class="mapping-grid-container shadow-lg">
        <dx-data-grid
            #countrySubdivisionMasterDataGrid
            id="countrySubdivisionMasterDataGrid"
            [allowColumnResizing]="true"
            [columnResizingMode]="'widget'"
            [allowColumnReordering]="true"
            [dataSource]="countrySubdivisionMasterDataSource"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [remoteOperations]="true"
            [hoverStateEnabled]="true"
            [(selectedRowKeys)]="countrySubdivisionMasterSelectedRowMap"
            (onSelectionChanged)="selectionMasterDataChangedHandler()"
            (onContentReady)="onReadyMasterGrid($event)"
            (onContextMenuPreparing)="masterDataGridContextMenu($event)"
            keyExpr="CountrySubdivisionGeographicalEntityId"
        >
            <dxo-state-storing
                    [enabled]="true"
                    type="custom"
                    [customLoad]="loadMasterState"
                    [customSave]="saveMasterState">
            </dxo-state-storing>
            <dxo-load-panel
                    [enabled]="false"
                    shadingColor="rgba(0,0,0,0.4)"
                    [showIndicator]="true"
                    [showPane]="true"
                    [shading]="true">
            </dxo-load-panel>
            <dxo-filter-panel [visible]="true"></dxo-filter-panel>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-pager
                    [visible]="true"
                    [allowedPageSizes]="[5, 10, 25, 50, 100]"
                    displayMode="compact"
                    [showPageSizeSelector]="true"
                    [showNavigationButtons]="false"
            >
            </dxo-pager>
            <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
            <dxo-selection mode="single"></dxo-selection>
            <dxo-column-chooser [enabled]="true" mode="dragAndDrop"></dxo-column-chooser>
            <dxi-column dataField="CountrySubdivisionGeographicalEntityId" caption="Geographical Entity Id" [allowHeaderFiltering]="false" [width]="140" [customizeText]="customizeCountrySubdivisionMappingId"></dxi-column>
            <dxi-column caption="Action" [allowHeaderFiltering]="false" [width]="90" cellTemplate="action" alignment="center"></dxi-column>
            <dxi-column dataField="CountryShortName">
                <dxo-header-filter [dataSource]="countryShortNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountryAlpha2Code" [visible]="false" caption="Country Code">
                <dxo-header-filter [dataSource]="countryAlpha2CodeHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountryAlpha3Code" [visible]="false">
                <dxo-header-filter [dataSource]="countryAlpha3CodeHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="ReportRegionList">
                <dxo-header-filter [dataSource]="reportRegionListHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionShortName" caption="Country Subdivision Name">
                <dxo-header-filter [dataSource]="countrySubdivisionShortNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionTypeName" caption="Country Subdivision Type">
                <dxo-header-filter [dataSource]="countrySubdivisionTypeNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionCode">
                <dxo-header-filter [dataSource]="countrySubdivisionCodeHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionParentCode" [visible]="false">
                <dxo-header-filter [dataSource]="countrySubdivisionParentCodeHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionParentShortName" [visible]="false">
                <dxo-header-filter [dataSource]="countrySubdivisionParentShortNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionParentTypeName" [visible]="false">
                <dxo-header-filter [dataSource]="countrySubdivisionParentTypeNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column caption="Data auditing" [visible]="false">
                <dxi-column dataField="CreatedByUserFullNameSortableOrPrincipalName" caption="Created By" [visible]="false">
                    <dxo-header-filter [dataSource]="createdByUserFullNameSortableOrPrincipalNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CreatedOn" caption="Create on" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="createdOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedByUserFullNameSortableOrPrincipalName" caption="Modified By" [visible]="false">
                    <dxo-header-filter [dataSource]="modifiedByUserFullNameSortableOrPrincipalNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedOn" caption="Modified on" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="reviewedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedByUserFullNameSortableOrPrincipalName" caption="Reviewed By" [visible]="false">
                    <dxo-header-filter [dataSource]="reviewedByUserFullNameSortableOrPrincipalNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedOn" caption="Reviewed on" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="reviewedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>
            <div *dxTemplate="let action of 'action'">
                <dx-button
                    class="mr-1"
                    icon="fas fa-map-marker-alt fa-1x"
                    hint="Map"
                    (onClick)="map(action?.data?.CountrySubdivisionGeographicalEntityId)"></dx-button>
            </div>
            <dxo-paging [pageSize]="5"></dxo-paging>
        </dx-data-grid>
    </div>
</div>
